"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _hooks = require("../../hooks");
var _utils = require("../../utils");
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _Row = _interopRequireDefault(require("../layout/Row"));
var _Column = _interopRequireDefault(require("../layout/Column"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  options: [],
  dropdownMode: 'push',
  placeholderProps: {},
  placeholder: '',
  className: '',
  wrapperTag: 'ul',
  itemTag: 'li',
  onSelect() {}
};
function Dropdown(props) {
  const {
    options,
    placeholder,
    placeholderProps,
    dropdownMode,
    className,
    wrapperTag,
    itemTag,
    onSelect
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const containerRef = (0, _react.useRef)(null);
  const {
    colors
  } = (0, _react2.useTheme)();
  const toggleIsOpen = e => {
    var _e$preventDefault;
    e === null || e === void 0 || (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 || _e$preventDefault.call(e);
    setIsOpen(!isOpen);
  };
  const handleSelect = option => {
    if (!option) return;
    onSelect === null || onSelect === void 0 || onSelect(option);
    setIsOpen(false);
  };
  (0, _hooks.useOutsideClick)(containerRef, toggleIsOpen, dropdownMode === 'float' && isOpen);
  return /*#__PURE__*/_react.default.createElement(Container, {
    gap: 0,
    isOpen: isOpen,
    forwardedRef: containerRef,
    className: className,
    type: dropdownMode,
    "aria-expanded": isOpen
  }, /*#__PURE__*/_react.default.createElement(StyledTypography, _extends({
    type: "default",
    weight: 700,
    size: 16,
    color: colors.MAIN.PRIMARY
  }, placeholderProps), /*#__PURE__*/_react.default.createElement(Trigger, {
    onClick: toggleIsOpen,
    as: "button",
    "aria-label": placeholder
  }, placeholder, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: isOpen ? 'remove' : 'add',
    size: 22,
    color: colors.MAIN.PRIMARY
  }))), /*#__PURE__*/_react.default.createElement(ListContainer, {
    gap: 0,
    isOpen: isOpen,
    dropdownMode: dropdownMode,
    as: wrapperTag,
    datasets: {
      type: 'dropdown-content-wrapper'
    }
  }, options.map((_ref, index) => {
    let {
      label,
      value,
      _html
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(ListItem, _extends({
      as: itemTag,
      key: index,
      onClick: () => handleSelect(value),
      children: label
    }, _html ? {
      dangerouslySetInnerHTML: {
        __html: _html
      }
    } : {}));
  })));
}
const Container = (0, _styled.default)(_Column.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  transition: all ease 0.1s;\n  cursor: initial;\n\n  ", "\n"])), _ref2 => {
  let {
    isOpen,
    dropdownMode
  } = _ref2;
  let styles = "\n      box-shadow: inset 0 0 0 1px #d9d9d9,0 4px 4px rgba(0, 0, 0, 0);\n      border-radius: 5px;\n    ";
  if (isOpen && dropdownMode === 'float') {
    styles += "\n        border-radius: 5px 5px 0 0;\n        box-shadow: inset 0 0 0 1px #d9d9d9,0 4px 4px rgba(0, 0, 0, 0.15);\n      ";
  }
  return styles;
});
const StyledTypography = (0, _styled.default)(_Typography.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const Trigger = (0, _styled.default)(_Row.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 15px;\n  text-decoration: none;\n  cursor: inherit;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  gap: 10px;\n  background: ", ";\n  border: 1px solid ", ";\n  cursor: pointer;\n  width: 100%;\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.NEUTRAL.BACKGROUND;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.NEUTRAL.SIDE;
});
const ListContainer = (0, _styled.default)(_Column.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), _ref5 => {
  let {
    dropdownMode,
    theme,
    isOpen
  } = _ref5;
  let styles = "\n      background: ".concat(theme.colors.NEUTRAL.BACKGROUND, ";\n    ");
  if (dropdownMode === 'float') {
    styles += "\n        position: absolute;\n        top: 44px;\n        left: 0;\n        right: 0;\n        box-shadow: inset 0 0 0 1px #d9d9d9,0 4px 4px rgba(0, 0, 0, 0.15);\n      ";
  }
  if (!isOpen) {
    styles += "\n        position: absolute;\n        width: 0;\n        height: 0;\n        overflow: hidden;\n        pointer-events: none;\n        padding: 0;\n      ";
  }
  return styles;
});
const ListItem = _styled.default.li(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 15px;\n  font-size: 14px;\n  font-weight: 400;\n\n  ", "\n"])), _ref6 => {
  let {
    theme,
    as: asProp
  } = _ref6;
  let styles = "\n      border: 1px solid ".concat(theme.colors.NEUTRAL.SIDE, ";\n    \n      &:hover {\n        cursor: pointer;\n        background: ").concat((0, _utils.hexToRGBA)(theme.colors.MAIN.PRIMARY, 0.05), ";\n      }\n    ");
  if (asProp !== 'li') {
    styles += "\n        &:hover {\n          cursor: normal;\n          background: ".concat(theme.colors.NEUTRAL.BACKGROUND, ";\n        }\n      ");
  }
  return styles;
});
var _default = exports.default = Dropdown;